export enum VoiceConnectivityMethod {
	None,
	TwilioPhoneNumber,
	TwilioSIPTrunking,
	Telerivet,
}

export enum AlphanumericSupport {
	None,
	RegistrationRequired,
	Dynamic,
}
export enum ServiceProvider {
	Twilio,
	AfricasTalking,
	Vodafone,
}

export enum PreSubmissionConfigurationStatus {
	Pending,
	Submitted,
	Rejected,
	Approved,
	Cancelled,
}

export enum BatchMessageTypeEnum {
	SMS = "SMS",
	Voice = "Voice",
	WhatsApp = "WhatsApp",
}

export enum IVRFlowTypeEnum {
	USSD = "USSD",
	SMS = "SMS",
	WhatsApp = "WhatsApp",
	Voice = "Voice",
}

export enum TemplateType {
	BatchMessaging,
	Survey,
	RequestForHelp,
}

export enum WidgetTypeEnum {
	PickLanguage = "PickLanguage",
	AskQuestion = "AskQuestion",
	SendMessage = "SendMessage",
	LogRequestForHelp = "LogRequestForHelp",
}

export enum FailureActionType {
	UseDefaultValue = "UseDefaultValue",
	SendMessageAndExit = "SendMessageAndExit",
	Exit = "Exit",
}

export enum RecurringMessageSchedule {
	Daily = "Daily",
	Weekly = "Weekly",
	Monthly = "Montly",
}

export enum UserPermissionsFormMode {
	Add = "Add",
	Edit = "Edit",
	Delete = "Delete",
}

export enum AccessRoles {
	BasicUser = "Basic User",
	CountryAdmin = "Country Admin",
	CountryApprover = "Country Approver",
}
